import actions from 'Actions';
import Empty from 'constants/empty';
import Cookies from 'utils/Cookies';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';

const RV_CATEGORY_DATA_CAP = 20;

function updateRvData(rvData) {
    return dispatch => dispatch(actions.addRecentlyViewedData(rvData || Empty.Array));
}

function readRvCategoryCookie(userId) {
    if (typeof document === 'undefined') {
        return [];
    }

    const cookieValue = Cookies.read('rvcat_' + userId);

    if (!cookieValue) {
        return [];
    }

    return cookieValue.split('&').filter(Boolean);
}

function updateRvCategoryData(userId) {
    return dispatch => {
        const cookieCategoryIds = readRvCategoryCookie(userId);
        const existingRaw = Storage.local.getItem(LOCAL_STORAGE.RV_CATEGORY_DATA);
        const existingData = Array.isArray(existingRaw) ? existingRaw : [];
        const merged = [...new Set([...cookieCategoryIds, ...existingData])].slice(0, RV_CATEGORY_DATA_CAP);

        Storage.local.setItem(LOCAL_STORAGE.RV_CATEGORY_DATA, merged);
        dispatch(actions.addRvCategoryData(merged));
    };
}

export default { updateRvData, readRvCategoryCookie, updateRvCategoryData };
